import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      // 问卷详情
      path: '/servey',
      name: 'Servey',
      component: () => import('../views/servey'),
      meta: { title: '' }
    },
    {
      path: '/serveyProgress',
      name: 'ServeyProgress',
      component: () => import('../views/servey/serveyProgress'),
      meta: { title: '问卷进度', keepAlive: true }
    },
    {
      path: '/creditsIntro',
      name: 'creditsIntro',
      component: () => import('../views/creditsIntro'),
      meta: { title: '学分说明' }
    },
    {
      path: '/holiday',
      redirect: '/holiday/apply',
      component: () => import('../views/holiday'),
      children: [
        {
          path: 'list',
          name: 'HolidayList',
          component: () => import('../views/holiday/list.vue'),
          meta: { title: '请假列表', keepAlive: true }
        },
        {
          path: 'apply',
          name: 'HolidayApply',
          component: () => import('../views/holiday/apply.vue'),
          meta: { title: '请假' }
        },
        {
          path: 'approval',
          name: 'HolidayApproval',
          component: () => import('../views/holiday/approval.vue'),
          meta: { title: '请假审批' }
        },
      ]
    },
    {
      path: '/leaveManage',
      name: 'leaveManage',
      component: () => import('../views/leaveManage'),
      meta: { title: '请假管理' }
    },
    {
      path: '/attendance',
      redirect: '/attendance/sign',
      name: 'attendance',
      component: () => import('../views/attendance'),
      children: [ 
        {
          path: 'sign',
          name: 'sign',
          component: () => import('../views/attendance/sign'),
          meta: { title: '点名' }
        },
        {
          path: 'view',
          name: 'view',
          component: () => import('../views/attendance/sign'),
          meta: { title: '点名' }
        },
        {
          path: 'bedroom',
          name: 'AttendanceBedroom',
          component: () => import('../views/attendance/bedroom'),
          meta: { title: '宿舍考勤' }
        },
        {
          path: 'board',
          name: 'AttendanceBoard',
          component: () => import('../views/attendance/board'),
          meta: { title: '考勤大数据', keepAlive: true }
        },
        {
          path: 'detail',
          name: 'AttendanceDetail',
          component: () => import('../views/attendance/detail'),
          meta: { title: '考勤详情'}
        }
      ]
    },
    {
      path: '/archives',
      component: () => import('../views/archives'),
      meta: { title: '学生档案' }
    },
    {
      path: '/examResults',
      component: () => import('../views/examResults'),
      meta: { title: '班级成绩单', keepAlive: true }
    },
    {
      path: '/personResults',
      component: () => import('../views/personResults'),
      meta: { title: '个人成绩分析' }
    },
    {
      path: '/message/:id',
      component: () => import('../views/message'),
      meta: { title: '消息推送' }
    },
    {
      path: '/news/:id',
      component: () => import('../views/news'),
      meta: { title: '新闻资讯' }
    },
    {
      path: '/bulletin/:id',
      name: 'Bulletin',
      component: () => import('../views/news'),
      meta: { title: '公告栏详情' }
    },
    {
      path: '/privacyPolicy',
      component: () => import('../views/privacyPolicy'),
      meta: { title: '智慧元艺术隐私政策' }
    },
    {
      path: '/serviceAgreement',
      component: () => import('../views/serviceAgreement'),
      meta: { title: '智慧元艺术用户协议' }
    },
    {
      path: '/login',
      component: () => import('../views/login'),
      meta: { title: '登录' }
    },
    {
      path: '/parents',
      component: () => import('../views/parents'),
    },
    {
      path: '/rollCallRecord',
      component: () => import('../views/rollCallRecord'),
      meta: { title: '点名记录' }
    },
    {
      path: '/correct',
      component: () => import('../views/correct'),
      meta: { title: '批改' }
    },
    {
      path: '/currentCredits',
      component: () => import('../views/currentCredits'),
      meta: { title: '当前学分' }
    },
    {
      path: '/facePunchLogs',
      component: () => import('../views/facePunchLogs'),
      meta: { title: '考勤打卡' }
    },
    {
      path: '/facePunchTypeIn',
      component: () => import('../views/facePunchTypeIn'),
      meta: { title: '打卡机人脸录入' }
    },
    {
      path: '/parentBindStu',
      component: () => import('../views/parentBindStu'),
      meta: { title: '家长绑定学生' }
    },
    {
      path: '/contactTeacher',
      component: () => import('../views/contactTeacher'),
      meta: { title: '联系老师' }
    },
    {
      path: '/teacherComments',
      component: () => import('../views/teacherComments'),
      meta: { title: '教师评语' }
    },
    {
      path: '/teacherComment',
      meta: { title: '教师评语' },
      component: () => import('../views/teacherComment'),
      children: [
        {
          path: 'list',
          component: () => import('../views/teacherComment/list'),
          meta: { title: '教师评语', keepAlive: true }
        },
        {
          path: 'add',
          component: () => import('../views/teacherComment/add'),
          meta: { title: '新增教师评语', keepAlive: true }
        }
      ]
    },
    {
      path: '/classSchedule',
      component: () => import('../views/classSchedule'),
      meta: { title: '课程表' }
    },
    {
      path: '/dailyWorks',
      component: () => import('../views/dailyWorks'),
      meta: { title: '每日作业' }
    },
    {
      path: '/studentDetail',
      component: () => import('../views/studentDetail'),
      meta: { title: '学生档案' }
    },
    {
      path: '/notice',
      component: () => import('../views/notice'),
      meta: { title: '系统消息' }
    },
    {
      path: '/assignHomework',
      component: () => import('../views/assignHomework'),
      meta: { title: '布置作业' }
    },
    {
      path: '/dailyHomework',
      component: () => import('../views/dailyHomework'),
      meta: { title: '今日作业' }
    },
    {
      path: '/excellentWorks',
      component: () => import('../views/excellentWorks'),
      meta: { title: '优秀作品' }
    },
    {
      path: '/redirect',
      component: () => import('../views/redirect'),
      meta: { title: '' }
    },
    {
      path: '/groupMembers/:class_id',
      component: () => import('../views/groupMembers'),
      meta: { title: '群组全部成员' }
    },
    {
      path: '/signature',
      component: () => import('../views/signature'),
      meta: { title: '签名' }
    },
    {
      path: '/growthTrack',
      meta: { title: '成长轨迹' },
      component: () => import('../views/growthTrack'),
      children: [
        {
          path: 'publish',
          component: () => import('../views/growthTrack/publish.vue'),
          meta: { title: '成长轨迹' }
        },
        {
          path: 'detail',
          component: () => import('../views/growthTrack/detail.vue'),
          meta: { title: '成长轨迹' }
        },
        {
          path: 'list',
          component: () => import('../views/growthTrack/list.vue'),
          meta: { title: '成长轨迹', keepAlive: true }
        }
      ]
    },
    {
      path: '/bedroom',
      meta: { title: '宿舍' },
      component: { render: h => h('router-view') },
      children: [
        {
          path: 'repair',
          meta: { title: '宿舍报修' },
          component: { render: h => h('router-view') },
          children: [
            {
              path: 'list',
              component: () => import('../views/bedroom/repair/list.vue'),
              meta: { title: '宿舍报修列表', keepAlive: true }
            },
            {
              path: 'apply',
              component: () => import('../views/bedroom/repair/apply.vue'),
              meta: { title: '宿舍报修申请' }
            },
            {
              path: 'approve',
              component: () => import('../views/bedroom/repair/approve.vue'),
              meta: { title: '宿舍报修审批' }
            }
          ]
        }
      ]
    },
    {
      path: '/mailbox',
      meta: { title: '校长信箱' },
      component: { render: h => h('router-view') },
      children: [
        {
          path: 'list',
          component: () => import('../views/mailBox/list.vue'),
          meta: { title: '校长信箱列表', keepAlive: true }
        },
        {
          path: 'apply',
          component: () => import('../views/mailBox/apply.vue'),
          meta: { title: '校长信箱表单' }
        },
        {
          path: 'approve',
          component: () => import('../views/mailBox/approve.vue'),
          meta: { title: '校长信箱详情' }
        }
      ]
    },
    {
      path: '/cloudDisk',
      meta: { title: '云盘', keepAlive: true },
      component: () => import('../views/cloudDisk/index.vue'),
    },
    {
      path: '/yxAddressBook',
      meta: { title: '艺信通讯录', silde: true },
      component: () => import('../views/yxAddressBook/index.vue'),
    },

    // 每个模块多提供一个入口 start
    {
      path: '/questionnaire',
      name: 'servey',
      component: () => import('../views/servey'),
      meta: { title: '调查问卷' }
    },
    {
      path: '/desOfScore',
      name: 'creditsIntro',
      component: () => import('../views/creditsIntro'),
      meta: { title: '学分说明' }
    },
    {
      path: '/vacation',
      redirect: '/vacation/submit',
      component: () => import('../views/holiday'),
      children: [
        {
          path: 'submit',
          name: 'apply',
          component: () => import('../views/holiday/apply.vue'),
          meta: { title: '请假' }
        },
        {
          path: 'process',
          name: 'approval',
          component: () => import('../views/holiday/approval.vue'),
          meta: { title: '请假审批' }
        }
      ]
    },
    {
      path: '/kq',
      redirect: '/kq/check',
      name: 'attendance',
      component: () => import('../views/attendance'),
      children: [
        {
          path: 'check',
          name: 'sign',
          component: () => import('../views/attendance/sign'),
          meta: { title: '点名' }
        },
        {
          path: 'read',
          name: 'view',
          component: () => import('../views/attendance/sign'),
          meta: { title: '点名' }
        },
      ]
    },
    {
      path: '/studentProfile',
      component: () => import('../views/archives'),
      meta: { title: '学生档案' }
    },
    {
      path: '/gradeOfClass',
      component: () => import('../views/examResults'),
      meta: { title: '班级成绩单', keepAlive: true }
    },
    {
      path: '/analysisOfStudent',
      component: () => import('../views/personResults'),
      meta: { title: '个人成绩分析' }
    },
    {
      path: '/push/:id',
      component: () => import('../views/message'),
      meta: { title: '消息推送' }
    },
    {
      path: '/article/:id',
      component: () => import('../views/news'),
      meta: { title: '新闻资讯' }
    },
    {
      path: '/yszc',
      component: () => import('../views/privacyPolicy'),
      meta: { title: '智慧元艺术隐私政策' }
    },
    // 每个模块多提供一个入口 end
  ],
  scrollBehavior () { // 页面跳转滚动到顶部
    return { x: 0, y: 0}
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js